import styled from "styled-components";
import bgHero from "../images/quadrak.jpg";

const HeroSection = styled.section`
  text-align: center;
`;

const HeroImage = styled.div`
  position: relative;
  background-image: url(${bgHero});
  background-size: cover;
  background-position: center;
  padding: 150px 24px;
  color: white;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(31, 41, 55, 0.8);
    z-index: 1;
  }

  @media (max-width: 768px) {
    padding: 100px 20px;
  }

  @media (max-width: 480px) {
    padding: 80px 16px;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;

  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
`;

const Title = styled.h1`
  font-size: 4.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  line-height: 1.1;

  @media (max-width: 1024px) {
    font-size: 3.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  max-width: 600px;
  margin: 0;
  line-height: 1.6;

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 0.95rem;
  }
`;

export default function Hero() {
  return (
    <HeroSection>
      <HeroImage>
        <HeroContent>
          <Title>
            Consultoria <br />
            Especializada <br />
            em Engenharia
          </Title>

          <Description>
            Soluções personalizadas para gestão de suas obras com foco em
            segurança, qualidade, custo e prazo. Análise de viabilidade de
            empreendimentos e coordenação de projetos.
          </Description>
        </HeroContent>
      </HeroImage>
    </HeroSection>
  );
}